import { type Ref } from 'vue';

/**
 * Composition API equivalent of modalActionsMixin, for components using <script setup>.
 * Callers must pass their own `emit` (from defineEmits) and, if the exposed actions
 * need to be callable from a parent ref, forward the return value to defineExpose themselves.
 */
export function useModalActions(modalRef: Ref<{ $el: HTMLElement } | null>, emit: (event: 'close') => void, options?: { onShown?: () => void, onClose?: () => void }) {
  function showModal() {
    const el = (modalRef.value as any).$el;
    ($ as any)(el).modal('show');
    if (options?.onShown) {
      ($ as any)(el).one('shown.bs.modal', options.onShown);
    }
  }
  function closeModal() {
    emit('close');
    ($ as any)((modalRef.value as any).$el).modal('hide');
  }
  function closeAllModals() {
    ($ as any)('.modal').modal('hide');
  }
  function modalClosed() {
    if (options?.onClose) {
      options.onClose();
    }
    emit('close');
  }

  return { showModal, closeModal, closeAllModals, modalClosed };
}
